<template>
    <div class="sidebar-left mt-2">
        <div class="sidebar">
            <!-- Sidebar Content -->
            <div :class="{ show: mqShallShowLeftSidebar }" class="sidebar-content">
                <!-- Sidebar close icon -->
                <span class="sidebar-close-icon">
                    <font-awesome-icon icon="xmark" @click="$emit('update:mq-shall-show-left-sidebar', false)" />
                </span>

                <div id="chat-filters-container">
                    <b-form class="mr-75 flex-grow-1" @reset="resetSearch" @submit="applySearch">
                        <b-input-group
                            :class="{
                                active:
                                    searchBarFormActive || (activeFilter.keyword && activeFilter.keyword.length > 2),
                            }"
                            class="input-group-merge w-100 round search-bar"
                        >
                            <b-form-input
                                v-model="activeFilter.keyword"
                                v-b-tooltip.hover.top="$t('validation.min-characters', { count: 3 })"
                                :placeholder="$t('Search')"
                                @blur="searchBarFormActive = false"
                                @click="searchBarFormActive = true"
                            />

                            <!--                            <template #append>

                            </template>-->

                            <b-input-group-append>
                                <b-button
                                    v-if="showResetButton"
                                    :class="{
                                        active: activeFilter.keyword && activeFilter.keyword.length > 2,
                                    }"
                                    class="clear-search-query"
                                    size="sm"
                                    type="reset"
                                    variant="light"
                                    @blur="searchBarFormActive = false"
                                    @click="searchBarFormActive = true"
                                >
                                    &times
                                </b-button>

                                <b-button
                                    :disabled="activeFilter.keyword.length < 3"
                                    type="submit"
                                    variant="light-alt"
                                    @blur="searchBarFormActive = false"
                                    @click="searchBarFormActive = true"
                                >
                                    <font-awesome-icon
                                        :icon="['far', 'magnifying-glass']"
                                        class="text-secondary-tint ml-1"
                                    />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form>

                    <div class="d-flex">
                        <b-form-checkbox
                            v-model="smartInbox"
                            v-b-tooltip.hover.top="$t('settings.account.smartInbox.label')"
                            :disabled="!smartInboxAvailable"
                            button
                            button-variant="light-alt"
                            class="mr-50 btn-square round-medium"
                            unchecked-value="0"
                            value="1"
                        >
                            <font-awesome-icon icon="arrow-down-big-small" />
                        </b-form-checkbox>

                        <div class="chat-filters">
                            <b-dropdown
                                id="container-filters-dropdown"
                                ref="dropdown"
                                v-b-tooltip.hover.top="$t('Filters')"
                                :toggle-class="
                                    filters.channels.length > 0 || filters.teams.length > 0 || filters.tags.length > 0
                                        ? 'active'
                                        : ''
                                "
                                class="btn-square round-medium"
                                no-caret
                                variant="light-alt"
                            >
                                <template #button-content class="p-0">
                                    <font-awesome-icon icon="filter" />
                                </template>

                                <b-dropdown-form class="filters-dropdown-form">
                                    <b-tabs>
                                        <b-tab>
                                            <template #title>
                                                {{ $t("settings.channels.Channels") }}
                                                <b-badge v-if="filters.channels.length > 0" variant="primary" />
                                            </template>

                                            <span v-if="channels && channels.length === 0">
                                                {{ $t("channels_not_available") }}
                                            </span>

                                            <b-list-group v-else flush>
                                                <b-list-group-item
                                                    v-for="filter in channels"
                                                    :key="filter.id"
                                                    class="d-flex"
                                                >
                                                    <b-form-group class="m-0">
                                                        <b-form-checkbox-group
                                                            v-model="filters.channels"
                                                            @input="setFilterToLocalStorage('channels', $event)"
                                                        >
                                                            <b-form-checkbox :value="filter.id">
                                                                {{ filter.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </b-form-group>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-tab>

                                        <b-tab>
                                            <template #title>
                                                {{ $t("settings.teams.Teams") }}
                                                <b-badge v-if="filters.teams.length > 0" variant="primary" />
                                            </template>

                                            <span v-if="teams.length === 0">{{ $t("teams-not-available") }}</span>

                                            <b-list-group v-else flush>
                                                <b-list-group-item
                                                    v-for="filter in teams"
                                                    :key="filter.id"
                                                    class="d-flex"
                                                >
                                                    <b-form-group class="m-0">
                                                        <b-form-checkbox-group
                                                            v-model="filters.teams"
                                                            @input="setFilterToLocalStorage('teams', $event)"
                                                        >
                                                            <b-form-checkbox :value="filter.id">
                                                                {{ filter.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </b-form-group>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-tab>

                                        <b-tab>
                                            <template #title>
                                                {{ $t("settings.tags.Tags") }}
                                                <b-badge v-if="filters.tags.length > 0" variant="primary" />
                                            </template>

                                            <span v-if="tags && tags.length === 0">{{ $t("tags-not-available") }}</span>

                                            <b-list-group v-else flush>
                                                <b-list-group-item
                                                    v-for="filter in tags"
                                                    :key="filter.id"
                                                    class="d-flex"
                                                >
                                                    <b-form-group class="m-0">
                                                        <b-form-checkbox-group
                                                            v-model="filters.tags"
                                                            @input="setFilterToLocalStorage('tags', $event)"
                                                        >
                                                            <b-form-checkbox :value="filter.id">
                                                                {{ filter.name }}
                                                            </b-form-checkbox>
                                                        </b-form-checkbox-group>
                                                    </b-form-group>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-tab>
                                    </b-tabs>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>

                        <!--                        <b-form-checkbox-->
                        <!--                            v-model="multiSelectEnabled"-->
                        <!--                            v-b-tooltip.hover.top="$t('multi-select')"-->
                        <!--                            :unchecked-value="false"-->
                        <!--                            :value="true"-->
                        <!--                            button-->
                        <!--                            button-variant="light-alt"-->
                        <!--                            class="ml-50 btn-square round-medium"-->
                        <!--                        >-->
                        <!--                            <font-awesome-icon icon="check-square" />-->
                        <!--                        </b-form-checkbox>-->
                    </div>
                </div>

                <status-filters :active-filter="activeFilter" @apply-filter="$emit('apply-filter', $event)" />

                <div class="chat-user-list-wrapper list-group">
                    <div v-if="isLoadingChats" class="mt-2 ml-2 mr-2">
                        <template v-for="index in 10">
                            <div class="d-flex justify-content-start">
                                <b-skeleton class="mr-50 round-large" size="34px" type="avatar"></b-skeleton>
                                <div class="flex-grow-1 pl-75">
                                    <b-skeleton class="mb-50" width="80%"></b-skeleton>
                                    <b-skeleton class="mb-25" width="100%"></b-skeleton>
                                </div>
                            </div>
                            <hr class="my-3 hr-skeleton" />
                        </template>
                    </div>

                    <template v-else>
                        <div
                            v-if="formattedChatsList.length === 0 && !isLoadingChats"
                            class="no-chats text-center pt-2"
                        >
                            <img :alt="$t('inbox.no-chats')" src="~@/assets/images/chats-zero-state.svg" />
                            <div class="mt-2">{{ $t("inbox.no-chats") }}</div>
                        </div>

                        <b-skeleton-wrapper v-else-if="!isLoadingChats">
                            <RecycleScroller
                                id="chat-list"
                                v-slot="{ item: chat }"
                                :item-size="106.233"
                                :items="formattedChatsList"
                                class="scroller"
                                key-field="id"
                            >
                                <chat
                                    :active-status-filter="activeFilter.status"
                                    :chat="chat"
                                    :class="{
                                        active:
                                            (activeChat &&
                                                activeChat.lastConversation &&
                                                activeChat.lastConversation.id === chat.id) ||
                                            multiSelectChats.find((selectedChat) => selectedChat.id === chat.id),
                                    }"
                                    :multi-select-chats.sync="multiSelectChats"
                                    :multi-select-enabled="multiSelectEnabled"
                                    :teams="teams"
                                    class="round-extra-large chat-entry"
                                    @click="$emit('update:mq-shall-show-left-sidebar', !!multiSelectEnabled)"
                                    @contextmenu.prevent="$refs.contextMenu.open($event, { chat })"
                                    @click.prevent="
                                        multiSelectEnabled
                                            ? setMultiSelectChats({
                                                  id: chat.id,
                                                  channelId: chat.channel.id,
                                                  identityId: chat.identity.id,
                                                  contactId: chat.contact.id,
                                                  userId: getUserData().id,
                                                  assignedUserId: chat.assignedUserId,
                                                  isBlocked: chat.contact.isBlocked ? 1 : 0,
                                                  isHighPriority: chat.contact.isHighPriority ? 1 : 0,
                                                  isRead: chat.read,
                                                  isArchived: chat.lastConversation.status === 'closed',
                                                  isDeleteable:
                                                      chat.channel.settings &&
                                                      chat.channel.settings.find(
                                                          (setting) => setting.name === 'allowDeleteConversation'
                                                      ) &&
                                                      Boolean(
                                                          chat.channel.settings.find(
                                                              (setting) => setting.name === 'allowDeleteConversation'
                                                          ).value
                                                      ),
                                              })
                                            : !activeChat ||
                                              !activeChat.lastConversation ||
                                              activeChat.lastConversation.id !== chat.id
                                            ? $emit('open-chat', {
                                                  chatId: chat.id,
                                                  channelId: chat.channel.id,
                                                  identityId: chat.identity.id,
                                                  read: chat.read,
                                              })
                                            : false
                                    "
                                />
                            </RecycleScroller>
                        </b-skeleton-wrapper>
                    </template>
                </div>
            </div>
        </div>

        <vue-context ref="contextMenu" v-slot="{ data }">
            <li v-if="multiSelectEnabled" class="p-1 border-bottom text-center">
                <strong>
                    {{
                        $t("with-amount-entity", {
                            amount: multiSelectChats.length,
                            entity: $tc("entities.conversation.conversations", multiSelectChats.length),
                        })
                    }}
                </strong>
            </li>
            <li v-for="menuItem in contextMenuData">
                <b-link
                    v-if="contextMenuItemVisible(menuItem, data)"
                    :key="menuItem.text"
                    :disabled="contextMenuItemDisabled(menuItem, data)"
                    class="d-flex align-items-center"
                    @click.prevent="onContextMenuItemClick(menuItem.eventName, data)"
                >
                    <font-awesome-icon
                        v-if="menuItem.icon"
                        :color="contextMenuItemColor(menuItem, data)"
                        :icon="menuItem.icon"
                    />
                    <span class="ml-75">{{ contextMenuItemText(menuItem, data) }}</span>
                </b-link>
            </li>
        </vue-context>
    </div>
</template>

<script>
import {
    BBadge,
    BButton,
    BDropdown,
    BDropdownForm,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BListGroup,
    BListGroupItem,
    BSkeleton,
    BSkeletonWrapper,
    BSpinner,
    BTab,
    BTabs,
    VBTooltip,
} from "bootstrap-vue";
import { computed, defineComponent } from "@vue/composition-api";
import useAppConfig from "@/composables/useAppConfig";
import chat from "./chat";
import statusFilters from "./statusFilters";
import { getUserData } from "@/auth/getUserData";
import VueContext from "vue-context";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import toastificationContent from "@/layouts/components/toastification/toastificationContent";
import i18n from "@/libs/i18n";
import { useToast } from "vue-toastification/composition";
import useUsers from "@/composables/useUsers";
import useUserSettings from "@/composables/useUserSettings";
import { isArray } from "lodash";
import useChats from "@/composables/useChats";

// Composables v2.1
import useTags from "@/composables/v2.1/useTags";
import useChannels from "@/composables/v2.1/useChannels";
import useContacts from "@/composables/v2.1/useContacts";
import useStoredMessages from "@/composables/v2.1/useStoredMessages";
import useArchiveChat from "@/composables/v2.1/useArchiveChat";
import useReadChat from "@/composables/v2.1/useReadChat";
import useMultiSelect from "@/composables/v2.1/useMultiSelect";
import { useInboxModuleType } from "@/composables/v2.1/useInboxModuleType";
import { InboxModuleType } from "@/types/inboxModule.type";
import useMessagingFilters from "@/composables/useMessagingFilters";
import useEmailFilters from "@/composables/useEmailFilters";
import useEmailStatusFilters from "@/composables/v2.1/useEmailStatusFilters";

export default defineComponent({
    components: {
        BBadge,
        BButton,
        BInputGroup,
        BDropdown,
        BDropdownForm,
        BTabs,
        BTab,
        BListGroup,
        BListGroupItem,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormInput,
        BInputGroupAppend,
        BSpinner,
        BLink,
        BForm,
        BSkeletonWrapper,
        BSkeleton,

        // Components
        VueContext,
        chat,
        statusFilters,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        formattedChatsList: {
            type: Array,
            required: true,
        },
        activeChat: {
            type: Object,
            required: false,
        },
        filters: {
            type: Object,
            required: true,
        },
        activeFilter: {
            type: Object,
            required: true,
        },
        mqShallShowLeftSidebar: {
            type: Boolean,
            required: true,
        },
        smartInboxAvailable: {
            type: Boolean,
            required: true,
        },
        deleteByIdentity: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contextMenuData: [
                {
                    icon: "user",
                    text: this.$t("chat-assign-to-me"),
                    eventName: "assign-chat",
                },
                {
                    icon: "envelope",
                    text: this.$t("entities.conversation.mark-as-read"),
                    eventName: "set-read",
                },
                {
                    icon: "envelope-open",
                    text: this.$t("entities.conversation.mark-as-unread"),
                    eventName: "set-unread",
                },
                {
                    icon: "crown",
                    text: this.$t("context-menu.contact.vip"),
                    textAlt: this.$t("context-menu.contact.unvip"),
                    eventName: "set-contact-priority",
                    color: "#ffc107",
                },
                {
                    icon: "ban",
                    text: this.$t("context-menu.contact.block"),
                    textAlt: this.$t("context-menu.contact.unblock"),
                    eventName: "set-contact-blocked",
                    color: "#ff594b",
                },
                {
                    icon: "archive",
                    text: this.$t("entities.conversation.Archive"),
                    eventName: "set-archive-chat",
                    color: "#007bff",
                },
                {
                    icon: "trash",
                    text: this.$t("Delete"),
                    eventName: "delete-chat",
                },
            ],
        };
    },
    methods: {
        applySearch(event) {
            event.preventDefault();

            if (this.activeFilter.keyword.length > 1 && this.activeFilter.keyword.length < 3) {
                return;
            }

            let status;
            if (this.activeFilter.keyword.length === 0) {
                const { statusFilters } = useEmailStatusFilters();
                status = statusFilters.new;
            }

            this.$emit("apply-filter", {
                filter: { keyword: this.activeFilter.keyword, status },
            });
        },
        resetSearch() {
            this.activeFilter.keyword = "";

            const { statusFilters } = useEmailStatusFilters();
            this.$emit("apply-filter", {
                filter: { keyword: this.activeFilter.keyword, status: statusFilters.new },
            });
        },
        onContextMenuItemClick(eventName, data) {
            // "data" is the chat entry from the formattedChatsList.

            const { multiSelectEnabled, multiSelectChats, clearMultiSelect } = useMultiSelect();
            let teamToAssign;

            switch (eventName) {
                case "assign-chat":
                    if (multiSelectEnabled.value) {
                        // You can only assign non-archived chats.
                        const nonArchivedChats = multiSelectChats.value.filter((chat) => !chat.isArchived);

                        // For now, clear the complete multi select.
                        clearMultiSelect();

                        return this.$emit("assign-chat", nonArchivedChats);
                    }

                    // Don't keep team assigned if user is not part of the team
                    teamToAssign = data.chat.assignedTeam?.id ?? data.chat.assignedTeamId;
                    if (teamToAssign && !this.isUserPartOfTeam(teamToAssign)) {
                        teamToAssign = null;
                    }

                    return this.$emit("assign-chat", {
                        id: data.chat.id,
                        channelId: data.chat.channel.id,
                        identityId: data.chat.identity.id,
                        tags: data.chat.tags,
                        userId: getUserData().id,
                        teamId: teamToAssign ?? this.getRandomUserTeamForChannel(data.chat.channel.id), // Don't overwrite current assigned team
                        status: data.chat.lastConversation.status,
                    });
                case "set-archive-chat":
                    if (multiSelectEnabled.value) {
                        // If at least one chat is NOT archived, archive the non-archived.
                        const nonArchivedChats = multiSelectChats.value.filter((chat) => !chat.isArchived);

                        if (nonArchivedChats.length > 0) {
                            clearMultiSelect();
                            return this.archiveChat(nonArchivedChats);
                        }

                        // If all selected chats are archived already, then unarchive them.
                        const archivedChats = multiSelectChats.value.filter((chat) => chat.isArchived);
                        clearMultiSelect();
                        return this.$emit("unarchive-chat", archivedChats);
                    }

                    if (data.chat.lastConversation.status === "open") {
                        return this.archiveChat({
                            id: data.chat.id,
                            channel: {
                                id: data.chat.channel.id,
                                platform: data.chat.channel.platform,
                            },
                            identityId: data.chat.identity.id,
                        });
                    }

                    return this.$emit("unarchive-chat", {
                        id: data.chat.id,
                        channel: {
                            id: data.chat.channel.id,
                            platform: data.chat.channel.platform,
                        },
                        identityId: data.chat.identity.id,
                        read: data.chat.read,
                        tags: data.chat.tags,
                        assignedUserId: data.chat.assignedUserId,
                        assignedTeamId: data.chat.assignedTeam?.id,
                        status: "open",
                    });
                case "set-read":
                    if (multiSelectEnabled.value) {
                        return this.setRead(multiSelectChats.value);
                    }

                    return this.setRead({
                        id: data.chat.id,
                        assignedUserId: data.chat.assignedUserId,
                        assignedTeamId: data.chat.assignedTeam?.id,
                        tags: data.chat.tags,
                        channel: {
                            id: data.chat.channel.id,
                            platform: data.chat.channel.platform,
                        },
                    });
                case "set-unread":
                    if (multiSelectEnabled.value) {
                        return this.setUnread(multiSelectChats.value);
                    }

                    return this.setUnread({
                        id: data.chat.id,
                        assignedUserId: data.chat.assignedUserId,
                        assignedTeamId: data.chat.assignedTeam?.id,
                        tags: data.chat.tags,
                        channel: {
                            id: data.chat.channel.id,
                            platform: data.chat.channel.platform,
                        },
                    });
                case "set-contact-priority":
                    if (multiSelectEnabled.value) {
                        let contacts = multiSelectChats.value.map((chat) => ({
                            id: chat.contactId,
                            isHighPriority: !chat.isHighPriority,
                        }));

                        // If we find at least one chat not high priority, then only set the high priority on those particular chats. Leave the rest as-is
                        const nonHighPriorityChats = multiSelectChats.value
                            .map((chat) => {
                                if (chat.isHighPriority === 0) {
                                    return {
                                        id: chat.contactId,
                                        isHighPriority: 1,
                                    };
                                }
                            })
                            .filter((chat) => chat);

                        if (nonHighPriorityChats.length > 0) {
                            contacts = nonHighPriorityChats;
                        }

                        // For now, clear the complete multi select.
                        clearMultiSelect();

                        return this.localUpdateContact(contacts);
                    }

                    return this.localUpdateContact({
                        id: data.chat.contact.id,
                        isHighPriority: !data.chat.contact.isHighPriority,
                    });
                case "set-contact-blocked":
                    if (multiSelectEnabled.value) {
                        let contacts = multiSelectChats.value.map((chat) => ({
                            id: chat.contactId,
                            isBlocked: !chat.isBlocked,
                        }));

                        // If we find at least one chat not blocked, then only block the non-blocked yet and let the already blocked as-is.
                        const nonBlockedChats = multiSelectChats.value
                            .map((chat) => {
                                if (chat.isBlocked === 0) {
                                    return {
                                        id: chat.contactId,
                                        isBlocked: 1,
                                    };
                                }
                            })
                            .filter((chat) => chat);

                        if (nonBlockedChats.length > 0) {
                            contacts = nonBlockedChats;
                        }

                        // For now, clear the complete multi select.
                        clearMultiSelect();

                        return this.localUpdateContact(contacts);
                    }

                    return this.localUpdateContact({
                        id: data.chat.contact.id,
                        isBlocked: !data.chat.contact.isBlocked,
                    });
                case "delete-chat":
                    if (multiSelectEnabled.value) {
                        // Only the chats the are allowed to delete by the channel setting.
                        const deleteableChats = multiSelectChats.value.filter((chat) => chat.isDeleteable);

                        return this.$emit("delete-chat", deleteableChats, this.deleteByIdentity);
                    }

                    return this.$emit(
                        "delete-chat",
                        {
                            id: data.chat.id,
                            identityId: data.chat.identity?.id,
                            platform: data.chat.channel?.platform,
                        },
                        this.deleteByIdentity
                    );
            }
        },
        contextMenuItemVisible(menuItem, data) {
            if (menuItem.eventName === "delete-chat") {
                const { multiSelectEnabled, multiSelectChats } = useMultiSelect();

                // If at least one selected chat is allowed to delete, set delete context menu item visible.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => chat.isDeleteable)) {
                    return true;
                }

                return (
                    data?.chat.channel.settings.find((setting) => setting.name === "allowDeleteConversation")?.value ===
                    "1"
                );
            }

            return true;
        },
        contextMenuItemDisabled(menuItem, data) {
            if (menuItem && menuItem.disabled) {
                return true;
            }

            const { multiSelectEnabled, multiSelectChats } = useMultiSelect();

            if (menuItem.eventName === "assign-chat") {
                // If at least one selected chat is not assigned yet to myself and its not archived, the assign to me menuitem should be available.
                if (
                    multiSelectEnabled &&
                    multiSelectChats.value.some((chat) => chat.assignedUserId !== getUserData().id && !chat.isArchived)
                ) {
                    return false;
                }

                return data?.chat.lastConversation.status === "closed" || data?.chat.assignee?.id === getUserData().id;
            }

            if (menuItem.eventName === "set-read") {
                // If at least one selected chat is not read yet, the set read menu item should be available.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isRead)) {
                    return false;
                }

                return (
                    data?.chat.lastConversation.status === "closed" || data?.chat.read /*||
                    !data?.chat.lastInboundMessageTime*/
                );
            }

            if (menuItem.eventName === "set-unread") {
                // If at least one selected chat is read, the set unread menu item should be available.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => chat.isRead)) {
                    return false;
                }

                return (
                    data?.chat.lastConversation.status === "closed" || !data?.chat.read /*||
                    !data?.chat.lastInboundMessageTime*/
                );
            }
        },
        contextMenuItemColor(menuItem, data) {
            if (!data) {
                return;
            }

            const { multiSelectEnabled, multiSelectChats } = useMultiSelect();

            if (menuItem.eventName === "set-contact-priority") {
                // If at least one chat is NOT high priority in multi select mode, return non-colored.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isHighPriority)) {
                    return;
                }

                if (data.chat.contact.isHighPriority) {
                    return menuItem.color;
                }
            }

            if (menuItem.eventName === "set-contact-blocked") {
                // If at least one chat is NOT high priority in multi select mode, return non-colored.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isBlocked)) {
                    return;
                }

                if (data.chat.contact.isBlocked) {
                    return menuItem.color;
                }
            }

            if (menuItem.eventName === "set-archive-chat") {
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isArchived)) {
                    return;
                }

                if (data.chat.lastConversation.status === "closed") {
                    return menuItem.color;
                }
            }
        },
        contextMenuItemText(menuItem, data) {
            if (!data) {
                return;
            }

            const { multiSelectEnabled, multiSelectChats } = useMultiSelect();

            if (menuItem.eventName === "set-contact-priority") {
                // If at least one chat is NOT high priority in multi select mode, show the normal text instead of alt text.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isHighPriority)) {
                    return menuItem.text;
                }

                if (data.chat.contact.isHighPriority) {
                    return menuItem.textAlt;
                }
            }

            if (menuItem.eventName === "set-contact-blocked") {
                // If at least one chat is NOT blocked in multi select mode, show the normal text instead of alt text.
                if (multiSelectEnabled && multiSelectChats.value.some((chat) => !chat.isBlocked)) {
                    return menuItem.text;
                }

                if (data.chat.contact.isBlocked) {
                    return menuItem.textAlt;
                }
            }

            return menuItem.text;
        },
    },
    setup(props) {
        const toast = useToast();

        const { isLoading: isLoadingChats } = useChats();

        /**
         * CHANNELS
         */
        const { channels, fetchChannels } = useChannels();
        fetchChannels({
            params: { fields: "id,name,provider,platform,identity,customerCareWindowLength", join: "teamChannels" },
        });

        /**
         * TAGS
         */
        const { tags, fetchTags } = useTags();
        fetchTags({ params: { fields: "id,name,color" } });

        /**
         * USERS AND TEAMS
         */
        const { teams, fetchTeams, fetchUsers, getRandomUserTeamForChannel, isUserPartOfTeam } = useUsers();
        fetchTeams({ fields: "name,color", join: "teamUsers||userId" });
        fetchUsers({
            fields: "id,name,displayName,status,pictureUrl",
            filter: ["active||$eq||1", "role||$ne||saysimple", "role||$ne||api"],
            join: "teams",
        });

        const { getUserSetting } = useUserSettings();

        const localTeams =
            getUserSetting("enforceTeamFilter", "0") === "1"
                ? computed(() => {
                      if (isArray(teams.value)) {
                          return teams.value.filter((team) =>
                              team.teamUsers.some((teamUser) => teamUser.userId === getUserData().id)
                          );
                      }
                      return [];
                  })
                : teams;

        /**
         * STORED MESSAGES
         */
        const { fetchStoredMessages } = useStoredMessages();
        fetchStoredMessages();

        /**
         * CONTACTS
         */
        const { fetchContacts, updateContact } = useContacts();
        fetchContacts({ params: { fields: "name,isHighPriority,isBlocked" } });

        const localUpdateContact = async (contact) => {
            const contacts = isArray(contact) ? contact : [contact];

            if (!contacts[0]) {
                return;
            }

            const updateResults = {
                ok: [],
                error: [],
            };

            await Promise.all(
                contacts.map(async (contact) => {
                    await updateContact(contact)
                        .then(() => updateResults.ok.push(contact))
                        .catch(() => updateResults.error.push(contact));
                })
            );

            let status = "success";
            let notificationText = i18n.t("toast.update.success-amount", {
                amount: updateResults.ok.length,
                entity: i18n.tc("entities.contact.contacts-tc", updateResults.ok.length),
            });

            if (updateResults.ok.length > 0 && updateResults.error.length > 0) {
                status = "warning";
                notificationText = i18n.t("toast.update.multiple-amount", {
                    amountOk: updateResults.ok.length,
                    entityOk: i18n.tc("entities.contact.contacts-tc", updateResults.ok.length),
                    amountError: updateResults.error.length,
                    entityError: i18n.tc("entities.contact.contacts-tc", updateResults.error.length),
                });
            } else if (updateResults.ok.length === 0 && updateResults.error.length > 0) {
                status = "error";
                notificationText = i18n.t("toast.update.error-amount", {
                    amount: updateResults.error.length,
                    entity: i18n.tc("entities.contact.contacts-tc", updateResults.error.length),
                });
            }

            toast({
                component: toastificationContent,
                props: {
                    title: i18n.t("entities.contact.Contact"),
                    text: notificationText,
                    icon: status === "error" ? "times" : "check",
                    variant: status,
                },
            });

            return updateResults;
        };

        const searchBarFormActive = false;

        const showResetButton = computed(
            () => props.filters.keyword !== props.activeFilter.keyword || props.activeFilter.keyword?.length > 2
        );

        const { smartInbox } = useAppConfig();
        const { archiveChat } = useArchiveChat();
        const { setRead, setUnread } = useReadChat(toast);
        const { multiSelectChats, multiSelectEnabled, setMultiSelectChats } = useMultiSelect(toast);

        // Earlier, this was done directly at the event in the template, moved it for now to here, to easily clear multi select.
        // Apparently, this should be moved to a filters composable, but that will cost more time.
        const { inboxModuleType } = useInboxModuleType();

        const { setFilterToLocalStorage } =
            inboxModuleType.value === InboxModuleType.MESSAGING ? useMessagingFilters() : useEmailFilters();

        return {
            channels,
            tags,
            teams: localTeams,

            localUpdateContact,
            smartInbox,
            searchBarFormActive,
            isLoadingChats,
            showResetButton,

            archiveChat,
            setRead,
            setUnread,
            localStorage,
            getUserData,
            setFilterToLocalStorage,

            multiSelectEnabled,
            multiSelectChats,
            setMultiSelectChats,
            getRandomUserTeamForChannel,
            isUserPartOfTeam,
        };
    },
});
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-context.scss";
@import "~@/assets/scss/components/inbox/chatLeftSidebar.scss";
@import "~@/assets/scss/tabs.scss";
</style>

<style scoped>
.scroller {
    height: 100%;
}

.user {
    height: 32%;
    padding: 0 12px;
    display: flex;
    align-items: center;
}
</style>
